import Auth from '@aws-amplify/auth';
import ErrorMessage, { IErrorMessage } from '@components/shared/message/ErrorMessage';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { captureException as SentryCaptureException } from '@sentry/node';

export const ProxyAxios = axios.create();

ProxyAxios
    .interceptors
    .request
    .use(
        async (req: AxiosRequestConfig) => {
            const user = await Auth.currentSession();
            if (!user)
                return req;
            Object.assign(req.headers, { Authorization: `bearer ${user.getAccessToken().getJwtToken()}` });
            return req;
        });

ProxyAxios
    .interceptors
    .response
    .use(
        (success) => success,
        (error: AxiosError) => {

            const { response: { status, data } } = error;

            //Don't throw unnecessary error log to sentry
            if (status > 404) {
                SentryCaptureException({
                    statusCode: status,
                    payload: JSON.stringify(data)
                })
            }

            return Promise.reject(error);
        }
    )

export function errorHandler(error: AxiosError) {
    const response = error.response;

    if (typeof document !== 'undefined') {
        //For non SSR page => pop-up an error message
        const ErrorProps = {
            code: response.status,
            message: `${response.statusText}`,
            description: response?.data?.message
        } as IErrorMessage;

        ErrorMessage(ErrorProps);
    }

    throw error;
}

export interface IRequest {
    method: 'get' | 'post' | 'put' | 'delete',
    url: string,
    data?: any
    errorHandler?: Function,
}

export function request(request: IRequest): Promise<any> {
    return ProxyAxios(request)
        .then(res => res.data || res)
        .catch(error => {
            //Handle expired token
            if (request.errorHandler)
                return request.errorHandler();

            return errorHandler(error);
        });
}

export function convertArrayParam(key: string, params: any[]): string {
    return `${params.map(item => `${key}=${item}`).join('&')}`;
}

export function configureAxiosBaseUrl(baseUrl: string) {
    ProxyAxios.defaults.baseURL = baseUrl;
}